const KL_TZ = "Asia/Kuala_Lumpur";
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function pad2(value) {
  return String(value).padStart(2, "0");
}

export function klDay(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: KL_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || "";
  const year = get("year");
  const month = get("month");
  const day = get("day");
  if (!year || !month || !day) return "";
  return `${year}-${month}-${day}`;
}

function shiftDay(day, delta) {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + delta);
  return date.toISOString().slice(0, 10);
}

export function isKlToday(value) {
  const day = klDay(value);
  return Boolean(day && day === klDay(new Date()));
}

export function formatAdminDateTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: KL_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || "";
  const month = MONTHS[Number(get("month")) - 1] || get("month");
  const time = `${pad2(get("hour"))}:${get("minute")} ${get("dayPeriod").toUpperCase().replace(/\./g, "")}`;
  const day = klDay(date);
  const today = klDay(new Date());
  if (day === today) return `Today ${time}`;
  if (day === shiftDay(today, -1)) return `Yesterday ${time}`;
  return `${get("day")}-${month}-${get("year")} ${time}`;
}

export function activityLineWithoutWhen(text) {
  return String(text || "")
    .replace(/, (Today|Yesterday) \d{2}:\d{2} [AP]M$/i, "")
    .replace(/, \d{2}-[A-Za-z]{3}-\d{4} \d{2}:\d{2} [AP]M$/i, "")
    .trim();
}
